
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecarrentalinpune() {



    const cardData =
    {
        keyword: 'Corporate Car Rental in Pune ',
        heading: 'etravo : Corporate Car Rental in Pune',
   "headingDescription": "eTravo offers reliable Corporate Car Rental in Pune, designed for businesses, professionals, and executives who value punctuality and comfort. Whether you need chauffeur-driven sedans for meetings, SUVs for executive travel, or fleet services for corporate events, eTravo provides well-maintained, GPS-enabled vehicles with flexible hourly, daily, and monthly plans—making it the perfect solution for airport transfers, business travel, and employee transportation across Pune’s key corporate hubs.",

"top": "Top Corporate Hubs in Pune with eTravo",

"topPlaces": [
  {
    "title": "Hinjewadi IT Park",
    "description": "Hinjewadi is Pune’s largest IT hub, home to major tech companies and multinational corporations. Divided into multiple phases, it attracts thousands of professionals daily, making it a prime location for corporate car rental and employee transportation services."
  },
  {
    "title": "Kharadi IT Park",
    "description": "Kharadi is a rapidly growing business district in Pune, housing EON IT Park and World Trade Center. It is a hotspot for IT companies and corporate offices, requiring reliable transport solutions for professionals and executives."
  },
  {
    "title": "Magarpatta City",
    "description": "Magarpatta City is a well-planned integrated township and IT hub featuring Cybercity. It hosts numerous global companies and offers a balanced work-life environment, making it ideal for corporate commuting services."
  },
  {
    "title": "Baner-Balewadi Business District",
    "description": "Baner and Balewadi have emerged as prominent commercial zones with a mix of IT firms, startups, and corporate offices. The area’s connectivity and infrastructure make it a key location for business travel."
  },
  {
    "title": "Viman Nagar",
    "description": "Located near Pune Airport, Viman Nagar is a strategic business hub with several corporate offices, hotels, and commercial centers, making it a preferred choice for executive travel and airport transfers."
  },
  {
    "title": "Koregaon Park",
    "description": "Koregaon Park is a premium locality known for its corporate offices, luxury hotels, and business centers. It is popular among executives and professionals for meetings and corporate stays."
  },
  {
    "title": "Wakad",
    "description": "Wakad is a fast-developing suburb near Hinjewadi, known for its residential and commercial growth. It serves as a key transit point for IT professionals commuting to nearby business hubs."
  },
  {
    "title": "Hadapsar",
    "description": "Hadapsar is a major commercial and industrial area in Pune, hosting IT parks like SP Infocity and Magarpatta. It is a crucial destination for corporate travel and employee transport services."
  },
  {
    "title": "Shivajinagar",
    "description": "Shivajinagar is a central business district in Pune with government offices, corporate establishments, and excellent connectivity, making it a vital area for business commuting."
  },
  {
    "title": "Pimpri-Chinchwad",
    "description": "Pimpri-Chinchwad is an industrial and commercial hub with numerous manufacturing companies and corporate offices. It plays a significant role in Pune’s business ecosystem and requires efficient corporate mobility solutions."
  }
],


 "services": [
{
"name": "Corporate Car Rental Pune",
"description": "eTravo offers reliable corporate car rental in Pune designed for businesses that demand punctuality, comfort, and professionalism. Whether it’s daily office commutes, executive meetings, or client visits, our service ensures smooth transportation across all major business hubs like Hinjewadi, Magarpatta, and Baner. With well-maintained vehicles and trained chauffeurs, we help companies maintain a strong professional image while ensuring hassle-free travel for employees and management."
},
{
"name": "Corporate Car Rentals Pune",
"description": "Our corporate car rentals in Pune are built to support flexible business needs, offering both short-term and long-term rental solutions. eTravo ensures that every vehicle is clean, comfortable, and ready for daily operations or special corporate requirements. From startups to large enterprises, we provide scalable transport options that enhance employee productivity and simplify travel planning."
},
{
"name": "Car Rental for Corporate Pune",
"description": "eTravo provides premium car rental for corporate use in Pune, ideal for official meetings, corporate events, and employee transport. Our fleet includes sedans, SUVs, and executive vehicles, ensuring a comfortable and professional experience for every journey. With on-time service and experienced drivers, businesses can rely on us for smooth and efficient mobility."
},
{
"name": "Business Car Hire Pune",
"description": "Choose eTravo’s business car hire in Pune for reliable and efficient corporate travel solutions. We cater to executives, teams, and corporate guests, ensuring timely pickups and drop-offs for meetings, conferences, and business operations. Our service focuses on comfort, punctuality, and professionalism to meet modern business demands."
},
{
"name": "Office Car Rental Pune",
"description": "Simplify daily office transportation with eTravo’s office car rental services in Pune. We provide dedicated vehicles for employee movement, inter-office travel, and client visits. Our solutions are designed to reduce travel stress and ensure smooth coordination between office locations and corporate zones."
},
{
"name": "Corporate Vehicle Rental Pune",
"description": "eTravo offers corporate vehicle rental in Pune with a wide range of cars suited for business use. From economical sedans to premium executive cars, we deliver cost-effective and flexible mobility solutions. Our service helps companies manage transportation needs efficiently while maintaining high service standards."
},
{
"name": "Company Car Hire Pune",
"description": "With eTravo’s company car hire in Pune, businesses get customized travel solutions tailored to their needs. Whether it’s employee transport, executive travel, or client handling, our services ensure convenience and reliability. We focus on delivering professional and consistent travel experiences for organizations of all sizes."
},
{
"name": "Executive Car Rental Pune",
"description": "Experience premium comfort with executive car rental in Pune by eTravo. Designed for senior management and VIP clients, our luxury vehicles offer privacy, smooth rides, and professional chauffeurs. Ideal for high-level meetings, airport transfers, and corporate events, our service reflects your brand’s professionalism."
},
{
"name": "Corporate Fleet Services Pune",
"description": "eTravo provides corporate fleet services in Pune for businesses that require multiple vehicles on a daily basis. Our fleet management solutions ensure timely availability, consistent quality, and smooth operations for employee transportation. We help companies streamline travel logistics while maintaining efficiency."
},
{
"name": "Professional Car Rental Pune",
"description": "Our professional car rental services in Pune are designed to meet high corporate standards. From well-trained drivers to regularly sanitized vehicles, eTravo ensures every journey is safe, comfortable, and efficient. We help businesses maintain professionalism in every aspect of travel."
},
{
"name": "Corporate Transport Services Pune",
"description": "eTravo’s corporate transport services in Pune offer structured and dependable mobility solutions for businesses. We manage employee and executive travel efficiently, ensuring punctuality and smooth coordination. Our services help organizations improve productivity by minimizing travel-related challenges."
},
{
"name": "Employee Transport Pune",
"description": "eTravo provides safe and reliable employee transport services in Pune for companies of all sizes. Our pickup and drop solutions are well-coordinated, ensuring timely arrivals and departures. With a focus on safety and comfort, we help businesses maintain workforce satisfaction and efficiency."
},
{
"name": "Corporate Cab Hire Pune",
"description": "eTravo offers flexible corporate cab hire in Pune for on-demand business travel. Whether it’s a quick meeting or a full-day booking, our cabs provide comfort, reliability, and professionalism. Our drivers are trained to deliver smooth travel experiences tailored for corporate needs."
},
{
"name": "Business Travel Cars Pune",
"description": "For seamless business travel, eTravo provides well-maintained cars in Pune suited for both local and outstation trips. Our service ensures a hassle-free experience, allowing professionals to focus on their work while we handle transportation. Comfort and punctuality remain our top priorities."
},
{
"name": "Corporate Mobility Services Pune",
"description": "eTravo’s corporate mobility services in Pune offer end-to-end transportation solutions for businesses. From planning routes to managing daily operations, we ensure efficient travel logistics for employees and executives. Our services are designed to optimize time, reduce costs, and improve overall mobility."
}
],
"tableData": [
["Corporate Car Rental Pune", "Corporate Car Rentals Pune"],
["Car Rental for Corporate Pune", "Business Car Hire Pune"],
["Office Car Rental Pune", "Corporate Vehicle Rental Pune"],
["Company Car Hire Pune", "Executive Car Rental Pune"],
["Corporate Fleet Services Pune", "Professional Car Rental Pune"],
["Corporate Transport Services Pune", "Employee Transport Pune"],
["Corporate Cab Hire Pune", "Business Travel Cars Pune"],
["Corporate Mobility Services Pune", ""]
],





"whychoose": [
    {
      "WhyChooseheading": "Reliable Corporate Car Rental in Pune",
      "WhyChoosedescription": "eTravo provides dependable corporate car rental services in Pune, ensuring smooth and professional transportation for businesses of all sizes across key commercial areas like Hinjewadi, Baner, and Magarpatta."
    },
    {
      "WhyChooseheading": "Wide Range of Corporate Vehicles",
      "WhyChoosedescription": "Our fleet includes sedans, SUVs, and luxury cars suitable for employee travel, executive meetings, and VIP transfers, offering the perfect vehicle for every corporate need."
    },
    {
      "WhyChooseheading": "On-Time Pickups and Drop Services",
      "WhyChoosedescription": "We prioritize punctuality for all corporate bookings, ensuring timely pickups and drop-offs for office commutes, meetings, and airport transfers without delays."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs for Business Travel",
      "WhyChoosedescription": "Our trained chauffeurs understand corporate etiquette and provide a safe, smooth, and respectful travel experience for employees, executives, and business guests."
    },
    {
      "WhyChooseheading": "Flexible Corporate Rental Plans",
      "WhyChoosedescription": "eTravo offers hourly, daily, monthly, and long-term rental packages, allowing businesses to choose customized solutions based on their operational requirements."
    },
    {
      "WhyChooseheading": "Transparent Billing and Cost Efficiency",
      "WhyChoosedescription": "We provide clear, GST-compliant invoices with no hidden charges, helping companies manage their travel budgets effectively and maintain financial transparency."
    },
    {
      "WhyChooseheading": "Clean and Well-Maintained Vehicles",
      "WhyChoosedescription": "All vehicles are regularly serviced and sanitized, ensuring a hygienic, comfortable, and reliable journey for every corporate trip."
    },
    {
      "WhyChooseheading": "24/7 Dedicated Corporate Support",
      "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, modifications, and urgent travel needs, ensuring uninterrupted corporate mobility."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is included in eTravo’s corporate car rental in Pune?',
            answer: 'eTravo’s corporate car rental in Pune includes chauffeur-driven vehicles, flexible booking options, airport transfers, and customized travel solutions for business meetings and employee transportation.',
        },
        {
            question: 'Can I book corporate car rental in Pune for long-term use?',
            answer: 'Yes, eTravo offers long-term corporate rental plans including monthly and yearly contracts tailored for companies and business operations.',
        },
        {
            question: 'What types of cars are available for corporate rental in Pune?',
            answer: 'Our fleet includes hatchbacks, sedans, SUVs, and luxury cars to suit employee travel, executive transport, and VIP requirements.',
        },
        {
            question: 'Does eTravo provide chauffeur-driven corporate cars in Pune?',
            answer: 'Yes, all our corporate car rentals come with professional chauffeurs trained in safety, punctuality, and corporate etiquette.',
        },
        {
            question: 'Is airport transfer included in corporate car rental services?',
            answer: 'Yes, we provide seamless airport pickup and drop services for corporate clients traveling to and from Pune Airport.',
        },
        {
            question: 'Can I schedule daily employee transport with eTravo in Pune?',
            answer: 'Yes, we offer daily office pickup and drop services for employees with route planning and fixed schedules.',
        },
        {
            question: 'Are your corporate car rental services available 24/7 in Pune?',
            answer: 'Yes, eTravo operates 24/7 to support business travel needs including late-night and early-morning corporate trips.',
        },
        {
            question: 'Do you provide GST billing for corporate bookings?',
            answer: 'Yes, we provide proper GST-compliant invoices for all corporate car rental bookings.',
        },
        {
            question: 'Can I customize corporate travel packages in Pune?',
            answer: 'Yes, we offer fully customized corporate travel plans based on your company’s requirements and budget.',
        },
        {
            question: 'How can I book corporate car rental in Pune with eTravo?',
            answer: 'You can easily book through our website or contact our support team for quick and hassle-free corporate booking assistance.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Rahul Patil',
        designation: 'Admin Manager, TechCore Solutions, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has been our go-to partner for corporate car rental in Pune. Their punctual service and clean vehicles make daily office travel smooth and stress-free.”',
    },
    {
        name: 'Ms. Priya Shah',
        designation: 'HR Head, Nexa Innovations, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We rely on eTravo for all our corporate travel needs in Pune. Their flexible plans and professional chauffeurs ensure a premium experience every time.”',
    },
];












    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];








const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Corporate Car Rental in Pune",
  "serviceType": "Corporate Car Rental",
  "description": "Professional corporate car rental services in Pune for business travel, employee transportation, executive travel, office mobility, and corporate transport requirements.",
  "provider": {
    "@type": "Organization",
    "name": "eTravo",
    "url": "https://www.etravo.in/"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "url": "https://www.etravo.in/corporate-car-rental-in-pune"
};



    return (
        <div>
<Helmet>
  <title>
    Corporate Car Rental in Pune | Business Car Hire & Corporate Transport | eTravo
  </title>

  <meta
    name="description"
    content="Corporate car rental in Pune for business travel, employee transport, executive rides and office mobility. Explore reliable corporate transport solutions from eTravo."
  />

  <link
    rel="canonical"
    href="https://www.etravo.in/corporate-car-rental-in-pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(serviceSchema)}
  </script>
</Helmet>

{/* <Helmet>
  <title>Corporate Car Rental in Pune | Business Car Hire & Corporate Transport Services | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate car rental in Pune with eTravo for business travel, employee transport, executive rides, and office mobility solutions. Reliable corporate fleet services." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet> */}


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/corporate-car-rental-pune.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecarrentalinpune;